
import styled from 'styled-components';
import Slider from '../../../element/ui/core/slider';

const StyledSlider = styled(Slider)`
  width: ${({ width }) => width || '100px'};
  max-width: ${({ width }) => (width === '100%' ? '100%' : width || '100px')};
  min-width: 0;
  user-select: none;
  margin-bottom: ${({ width }) => (width === '100%' ? 0 : '24px')};

  && {
    display: block;
    width: 100%;
    height: 4px;
    min-height: 4px;
    overflow: visible;
    box-sizing: content-box;
    padding: 14px 6px 0;
    margin-bottom: 30px;
    position: relative;
  }

  .respark_Slider-rail {
    opacity: 1;
    background-color: #dee1ec;
  }

  .respark_Slider-annotation {
    font-size: 11px;
    line-height: 1.35;
    position: absolute;
    left: 0;
    right: 0;
    top: calc(100% + 8px);
    margin: 0;
    padding: 8px 2px 0;
    display: flex;
    justify-content: space-between;
    gap: 12px;
    overflow: visible;

    span {
      white-space: nowrap;
      min-width: 2.5em;
    }
  }
`;

export { StyledSlider };
